import React from "react";

function SideCont() {
  return (
    <>
      <section className="sidebar-head">
        <div className="row sidebar-row">
          <div className="col-lg-12 sidebar-col">
            <div className="siderbar-heading">
              <img src={require("../../Assets/img/copy-link.png")} alt="" />
              <h3>Copy Link</h3>
            </div>
            <div className="sidebar-inner-head">
              <img src={require("../../Assets/img/outline.png")} alt="" />
              <h3>Outline</h3>
            </div>
            <div className="siderbar-inner-content">
              <p>Developer quick start</p>
              <p>Keeping up with Gaming Arcade</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default SideCont;
